import React from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'

import { PublicLayoutComponent } from '../../ui'
import { Login, Signup, SignupConfirmation } from '../../pages'

export const PublicRouter = () => {
  const location = useLocation()

  return (
    <PublicLayoutComponent>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/signup/confirmation/:signupToken" component={SignupConfirmation} />
        <Route path="/signup" component={Signup} />
        <Redirect from="*" to={{ pathname: '/login', state: { from: location } }} />
      </Switch>
    </PublicLayoutComponent>
  )
}
